import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ParentEvents } from '../../../utils/parent-events.service';

export interface Breadcrumb {
    title: string;
    percent: number;
}

@Component({
    selector: 'thr-contract-progress',
    templateUrl: './contract-progress.component.html',
    styleUrls: ['./contract-progress.component.scss'],
})
export class ContractProgressComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    public percent = 0;

    @Input()
    public breadcrumbs: Breadcrumb[] = [
        { title: 'progress.form', percent: 10 },
        { title: 'progress.participants', percent: 20 },
        { title: 'progress.select-sign', percent: 30 },
        { title: 'progress.test', percent: 40 },
        { title: 'progress.test-result', percent: 60 },
        { title: 'progress.full-data', percent: 80 },
        { title: 'progress.complete', percent: 100 },
    ];

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
